import * as React from 'react';
import * as intl from 'react-intl-universal';
import { Col, Row } from 'antd';
import Uploader from 'common/components/Form/Field/Upload';

export default class BgImg extends React.Component<any> {
    form: any;
    cache: string;
    state: any = {
        selected: '',
        isLoading: true,
        file: '',
    };

    /**
     * 选择默认图片
     * @param selected
     * @returns {() => void}
     */
    selectHandler = (selected: any) => () => {
        this.setState({ selected, file: '' }, () => {
            this.props.onChange(selected);
        });
    };

    render() {
        const { staticView, disabled, pictures, addClass } = this.props;
        const { selected } = this.state;
        const config = {
            max: 1,
            action: '/v2/common/file/upload',
            onChange: (value: any) => {
                if (value) {
                    this.setState({ selected: value[0] && value[0].aws }, () => {
                        this.props.onChange(value[0] && value[0].aws);
                    });
                }
            },
            defaultValue: [{url: selected || this.props.selected}]
        };
        return (
            <div className='bgImg'>
                <Uploader action={config.action} max={config.max} onChange={config.onChange} value={config.defaultValue}
                    discompress={true} disabled={disabled} addClass={addClass}/>
                {!(staticView && disabled) && <div>
                    <p>{intl.get('Setting.PlatformRecommendedBgImg')}</p>
                    <Row type='flex'>
                        {pictures.map(({ url, key }: any) => url && (
                            <Col key={key} span={4}>
                                <div onClick={this.selectHandler(url)}>
                                    <img src={url}/>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>}
            </div>
        );
    }
}
